import React from 'react';
import './onboardingStatusHeader.scss';

import { PageHeader } from 'pepsico-ds';

export const OnboardingStatusHeader = ({ title = '', className = '' }) => {
  return (
    <div
      className={`admin-profile_onboarding-status-header flex flex-col items-start justify-start rounded-lg ${className}`}>
      <div className='flex flex-row items-center justify-start'>
        <PageHeader title={title} />
      </div>
    </div>
  );
};
